<template>
  <div class="swiper">
    <swiper ref="entiretySwiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) of getSwiperArr" :key="index">
        <div
        class="swiperList-img-box"
        @click="getIndex(itemList)"
        v-for="itemList of item" :key="itemList.id">
          <div :class="['swiperlist', {'highlight' :itemList.indexId==indexId}]" >
            <div class="list-img">
              <img v-if="itemList.indexId==indexId" src="../../../../static/images/zheng.png" alt="">
              <img v-else src="../../../../static/images/zheng_nor.png" alt="">
            </div>
            <div class="list-text">
              <h2>{{itemList.name}}</h2>
              <!-- 导入指标 -->
              <div v-if="itemList.classification === 5">
                <p><span>{{itemList.achievementRateName}}</span><span>{{itemList.achievementRate}}{{itemList.unit}}</span></p>
              </div>
              <!-- 应用指标 -->
              <div v-else>
                <p v-if="itemList.currateShow"><span>{{itemList.achievementRateName}}</span><span>{{itemList.achievementRate}}{{itemList.achievementRateUnit}}</span></p>
                <p><span>年同比</span><span>{{itemList.onYearRate}}{{itemList.onYearRateUnit}}</span></p>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'ListSwiper',
  data () {
    return {
      changeFlag: true,
      swiperOption: {
        pagination: '.swiper-pagination'
        // loop: false,
        // slidesPerView: 3,
        // slidesPerGroup: 3
      },
      indexId: '',
      getSwiper: [],
      // rateFlag: falOnese,
      getSwiperArr: Array, // 构建数组
      boxText: ''
    }
  },
  props: {
    swiperList: {
      type: Array,
      require: true
    }
  },
  computed: {
    getQuota () {
      return this.$store.state.entirety.quota
    }
  },
  watch: {
    swiperList () {
      if (this.swiperList.length === 0) { return }
      // if (this.$store.state.entirety.type === '0102') {
      //   this.rateFlag = false
      // } else {
      //   this.rateFlag = true
      // }
      this.getSwiper = this.swiperList.concat()
      // this.getSwiperLength = Math.ceil(this.getSwiper.length/ 3 ) // 计算swiper共多少组
      this.getSwiper.sort((a, b) => a.rank - b.rank)
      let selectedData = this.getIndexId() === false ? this.getSwiper[0] : this.getIndexId()
      this.indexId = selectedData.indexId
      // 通过选中的数据进行quotaCard中的数据
      this.$emit('changeswiper', selectedData)
      this.$store.commit('ENTIRETY_SET_QUOTA', selectedData.indexId)
      this.$store.commit('ENTIRETY_SET_QUOTA_NAME', selectedData.name)
      this.$store.commit('ENTIRETY_SET_ClASSIFICATION', selectedData.classification)
      localStorage.setItem('quotaname', selectedData.name)
      for (let i = 0; i < this.getSwiper.length; i++) {
        if (this.getSwiper[i].onYearRate === null) {
          this.getSwiper[i].onYearRate = '--'
        }
        if (this.getSwiper[i].achievementRate === null) {
          this.getSwiper[i].achievementRate = '--'
        }
      }
      this.swiperListChange()
    }
  },
  methods: {
    // 滑动到相应的swiper高亮的位置
    swiperMoveToSlide (index) {
      this.$refs.entiretySwiper.swiper.slideTo(index, 200, false) // 切换到对应的slide，速度为1秒
    },
    swiperListChange () {
      // swiper渲染 冒泡方法，添加数据
      var numArr = 0
      var NunArrGetSwiper = []
      let moveIndex = 0
      for (var i = 0; this.getSwiper.length > i; i++) {
        if (i % 3 === 0) {
          if (i !== 0) {
            numArr++
          }
          NunArrGetSwiper[numArr] = []
        }
        if (this.getSwiper[i].indexId === this.indexId) {
          moveIndex = numArr // 获取对应滑动到对应位置的下标
        }
        NunArrGetSwiper[numArr].push(this.getSwiper[i])
      }
      this.getSwiperArr = NunArrGetSwiper
      setTimeout(() => { //
        this.swiperMoveToSlide(moveIndex) // 执行滑动到对应下标的位置
      }, 200)
    },
    getIndex (item) {
      this.$emit('changeswiper', item)
      this.indexId = item.indexId
      this.$store.commit('ENTIRETY_SET_QUOTA', item.indexId)
      this.$store.commit('ENTIRETY_SET_QUOTA_NAME', item.name)
      this.$store.commit('ENTIRETY_SET_ClASSIFICATION', item.classification)
      this.$store.commit('SET_HEADER_FLAG', false)
      localStorage.setItem('quotaname', item.name)
    },
    getIndexId () {
      for (let i = 0; i < this.getSwiper.length; i++) {
        if (this.indexId === this.getSwiper[i].indexId && !this.$store.state.user.headerFlag) {
          return this.getSwiper[i]
        }
      }
      return false
    }
  },
  created () {
    if (this.$store.state.entirety.quota) {
      this.indexId = this.$store.state.entirety.quota
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
  >>>.swiperList-img-box{
    width: 33.3% !important
    display: inline-block
  }
  >>>.swiper-slide.swiper-slide-active{
    display: flex;
  }
  >>>.swiper-slide.swiper-slide-next{
    display: flex
  }
  .swiper>>>.swiper-container-horizontal > .swiper-pagination-bullets{
    bottom:2px;
  }
  .swiper>>>.swiper-pagination-bullet-active{
    background:rgba(51,153,255,1);
  }
  .swiper>>>.swiper-container{
    height :100%;
    width : 100%
  }
  .swiper>>>.swiper-wrapper{
    align-items : center;
    height: 85%;
  }
  .swiper-slide{
    // flex : 1;
    // width : 1.08rem;
    // height : 1rem;
  }
  .swiper{
    display : flex;
    overflow : hidden;
    width : 100%;
    height : 1.6rem;
    min-height : 1.6rem;
    background:rgba(255,255,255,1);
    padding: 0.1rem 0;
  }
  .swiper .swiperList-img-box{
    display : flex;
    width : 100%;
    height : 100%;
  }
  .swiperlist{
    // height : 200px;
  }

  .swiperlist{
    position : relative;
    overflow : hidden;
    flex : 1;
    margin : .05rem;
    background : #fff;
    border-radius:6px;
    box-shadow: 2px 2px 5px rgba(141,141,141,0.41);
    color : #000;
  }
  .list-text{
    height : 100%;
  }
  .swiperlist p{
    padding-top : .02rem;
    // padding-left : .1rem;
    font-size : .13rem;
    font-weight:500;
    line-height: 1.3;
    // max-width: 68%;

  }
  .swiperlist h2{
    font-size : .14rem;
    padding-top : .1rem;
    // padding-left : .1rem;
    margin-bottom : .04rem;
    line-height : 1;
    min-height : 36%;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .highlight{
    background-image : url(../../../../static/images/bg_card.png);
    background-repeat : no-repeat;
    background-size: cover;
    color : #fff;
  }
  .list-img{
    width: 90%;
    margin: 0 auto;
  }
  .list-text{
    width: 90%;
    margin: 0 auto;
  }
  .list-text span{
    line-height : 1;
  }
  .list-text span:nth-child(2){
    float: right;
    // padding-right: 0.1rem
  }
  .list-img img{
    width: .24rem;
    height: .24rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/Swiper.vue